import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

// Mismo marco que la confirmación de borrar una plantilla o deshacer una
// parada: icono, texto y fila de botones centrada (tarjeta blanca).
import {
  ActionButton,
  ButtonRow,
  Container,
  ContainerText,
  ModalContainerStyled,
  Text,
  Title,
} from '../DeleteRoutePresetModal/styles';
import { AlertIcon } from '../../../../assets/icons/AlertIcon';

export interface UnreviewAllSegmentsModalData {
  /** Quita las marcas. Es inmediato (estado optimista): no hay que esperarlo. */
  onConfirm: () => void;
}

interface ModalProps {
  onClickClose: () => void;
  data?: UnreviewAllSegmentsModalData;
}

/**
 * «¿Desmarcar todos?» (tramos revisados, spec 2026-10-27 § 9): la casilla de
 * cabecera con todos los tramos marcados se pierde el progreso de golpe, así
 * que se confirma antes. Cancelar no manda nada.
 */
export const UnreviewAllSegmentsModal = ({
  onClickClose,
  data,
}: ModalProps): JSX.Element => {
  const { t } = useTranslation(['pages', 'buttons']);
  const theme = useTheme();

  const handleConfirm = () => {
    data?.onConfirm();
    onClickClose();
  };

  return (
    <ModalContainerStyled
      width={50}
      onClickClose={onClickClose}
      fill={theme.colors.black}
    >
      <Container
        role="dialog"
        aria-modal="true"
        aria-label={t('pages:surveillance.segmentReview.clearAll.title')}
      >
        <AlertIcon />
        <ContainerText>
          <Title variant="semiBold">
            {t('pages:surveillance.segmentReview.clearAll.title')}
          </Title>
          <Text size="M" colorText="greyDark">
            {t('pages:surveillance.segmentReview.clearAll.body')}
          </Text>
        </ContainerText>
        <ButtonRow>
          <ActionButton
            type="button"
            text={t('buttons:cancel')}
            variant="secondary"
            onClick={onClickClose}
          />
          <ActionButton
            type="button"
            text={t('buttons:confirm')}
            onClick={handleConfirm}
            data-testid="unreview-all-confirm"
          />
        </ButtonRow>
      </Container>
    </ModalContainerStyled>
  );
};

export default UnreviewAllSegmentsModal;
